// extracted by mini-css-extract-plugin
export default {"container":"page_container__98xhe","search":"page_search__7oj0T","emptyHint":"page_emptyHint__zoZ7H","list":"page_list__k9AKq"};